import React from 'react';
import clsx from 'clsx';
import { isSliderFocusedAtom } from './player-controls-scrubber-base';
import { useAtomValue } from 'jotai';
import styles from './player-controls-scrubber.module.scss';

interface Props {
  disableFastForward: boolean;
  fastForwardLimitProgress: number;
}

export const PlayerControlsScrubberBaseFastForwardLimit: React.FC<Props> = (props: Props) => {
  const { disableFastForward, fastForwardLimitProgress } = props;
  const isSliderFocused = useAtomValue(isSliderFocusedAtom);

  if (!disableFastForward) return null;

  return (
    <>
      <div
        className={clsx(styles['player-controls-scrubber-base__fast-forward-limit'], {
          [styles['player-controls-scrubber-base__fast-forward-limit--focused']]: isSliderFocused
        })}
        style={{ width: `${fastForwardLimitProgress}%` }}
      />
      <span
        className={clsx(styles['player-controls-scrubber-base__fast-forward-content-line'], {
          [styles['player-controls-scrubber-base__fast-forward-content-line--focused']]: isSliderFocused
        })}
        style={{ marginLeft: `${fastForwardLimitProgress}%` }}
      />
    </>
  );
};

export default React.memo(PlayerControlsScrubberBaseFastForwardLimit);
